<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">Browse Course</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="search-section"
                  v-if="
                    userPermissions.edication_category_filter == 1 ||
                      userPermissions.edication_category_filter == 1 ||
                      userPermissions.edication_category_filter == 1
                  "
                >
                  <div class="row">
                    <!-- <div class="col-md-3">
                      <div
                        class="form-group"
                        v-if="userPermissions.edication_category_filter == 1"
                      >
                        <select
                          v-model="education_id"
                          class="form-control select2"
                        >
                          <option value="" selected
                            >Select Education Category</option
                          >
                          <option
                            v-for="(education_type, key) in education"
                            :key="key"
                            :value="education_type.id"
                            >{{ education_type.text }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div
                        class="form-group"
                        v-if="userPermissions.offering_body_filter == 1"
                      >
                        <select
                          v-model="offering_type_id"
                          class="form-control select2"
                        >
                          <option value="" selected
                            >Select Offering Body</option
                          >
                          <option
                            v-for="(offer, key) in offering"
                            :key="key"
                            :value="offer.id"
                            >{{ offer.text }}</option
                          >
                        </select>
                      </div>
                    </div> -->
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="text" v-model="keyword" class="form-control" placeholder="Search">
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div
                        class="form-group"
                        v-if="userPermissions.grade_filter == 1"
                      >
                        <select v-model="grade_id" class="form-control select2">
                          <option value="" selected>Select a Grade</option>
                          <option
                            v-for="(grade, key) in grades"
                            :key="key"
                            :value="grade.id"
                            >{{ grade.text }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <!-- <div class="col-md-3">
                      <div class="form-group">
                        <select v-model="duration" class="form-control select2">
                          <option value="" selected>Select duration</option>
                          <option
                            v-for="(duration, key) in durations"
                            :key="key"
                            :value="duration.value"
                            >{{ duration.text }}</option
                          >
                        </select>
                      </div>
                    </div> -->
                    <div class="col-md-2">
                      <button
                        type="submit"
                        @click="searchCourse"
                        class="btn btn-primary btn-info"
                      >
                        Search Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="loaderlist">
              <div class="col-md-3 col-lg-3 col-xl-3 course-card padding-r-7">
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
              <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
              <div
                class="col-md-3 col-lg-3 col-xl-3 course-card padding-l-7 mobile-hide"
              >
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
              <div
                class="col-md-3 col-lg-3 col-xl-3 course-card padding-l-7 mobile-hide"
              >
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div id="accordion" v-if="course_list != ''">
                  <div
                    class="card"
                    v-for="(course_type, index) in course_list"
                    :key="index"
                  >
                    <div class="card-header" :id="'heading' + index">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link"
                          data-toggle="collapse"
                          :data-target="'#collapse' + index"
                          aria-expanded="true"
                          :aria-controls="'collapse' + index"
                        >
                          <h5 v-if="index == 'Full'">{{ index }} Courses</h5>
                          <h5 v-else>{{ index }}</h5>
                        </button>
                      </h5>
                    </div>

                    <div
                      :id="'collapse' + index"
                      class="collapse show"
                      :aria-labelledby="'heading' + index"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div
                            v-for="(course, index) in course_type"
                            :key="index"
                            class="col-md-4 col-lg-3 col-xl-3 course-card"
                          >
                            <div class="course-card">
                              <div class="modern-card">
                                <div :class="!course.is_bundle ? 'modern-head' : 'modern-head-bundle-course' ">
                                  <h2>{{ course.name }}</h2>
                                </div>
                                <div
                                  class="bundle-pack"
                                  v-if="course.is_bundle"
                                >
                                  <span v-if="course.bundle_course.length > 1">
                                    <span>
                                      {{ course.bundle_course.length }}
                                    </span>
                                    <b>Courses</b>
                                  </span>

                                  <span v-if="course.bundle_course.length == 0">
                                    <span>
                                      {{ course.bundle_course.length }}
                                    </span>
                                    <b>Courses</b>
                                  </span>

                                  <span v-if="course.bundle_course.length == 1">
                                    <span>
                                      {{ course.bundle_course.length }}
                                    </span>
                                    <b>Course</b>
                                  </span>
                                </div>
                                <div class="modern-stat">
                                  <div class="row" v-if="course.hrs">
                                    <div
                                      class="col-6 text-center modern-stat-border"
                                    >
                                      <span v-if="course.duration == 0">
                                        {{ course.duration }} Months
                                      </span>
                                      <span v-else-if="course.duration == 1">
                                        {{ course.duration }} Month
                                      </span>
                                      <span v-else-if="course.duration > 1">
                                        {{ course.duration }} Months
                                      </span>
                                    </div>
                                    <div class="col-6 text-center">
                                      <span v-if="course.hrs == 0">
                                        {{ course.hrs }} Hours
                                      </span>
                                      <span v-else-if="course.hrs == 1">
                                        {{ course.hrs }} Hour
                                      </span>
                                      <span v-else-if="course.hrs > 1">
                                        {{ course.hrs }} Hours
                                      </span>
                                    </div>
                                  </div>
                                  <div class="row" v-else>
                                    <div class="col-12 text-center">
                                      <span v-if="course.duration == 0">
                                        {{ course.duration }} Months
                                      </span>
                                      <span v-else-if="course.duration == 1">
                                        {{ course.duration }} Month
                                      </span>
                                      <span v-else-if="course.duration > 1">
                                        {{ course.duration }} Months
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="modern-stat sub-item"
                                  style="color:#222;font-weight:700"
                                >
                                  <div class="row p-1" v-if="course.is_bundle">
                                    <div
                                      class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center sub-items-border-right"
                                    >
                                      <span
                                        v-if="course.bundle_course.length == 0"
                                      >
                                        {{
                                          course.bundle_course.length
                                        }}
                                        Courses
                                      </span>
                                      <span
                                        v-else-if="
                                          course.bundle_course.length == 1
                                        "
                                      >
                                        {{ course.bundle_course.length }} Course
                                      </span>
                                      <span
                                        v-else-if="
                                          course.bundle_course.length > 1
                                        "
                                      >
                                        {{
                                          course.bundle_course.length
                                        }}
                                        Courses
                                      </span>
                                    </div>
                                    <div
                                      class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center sub-items-border-right"
                                    >
                                      <span v-if="course.subject_count == 0">
                                        {{ course.subject_count }} Subjects
                                      </span>
                                      <span
                                        v-else-if="course.subject_count == 1"
                                      >
                                        {{ course.subject_count }} Subject
                                      </span>
                                      <span
                                        v-else-if="course.subject_count > 1"
                                      >
                                        {{ course.subject_count }} Subjects
                                      </span>
                                    </div>
                                    <div
                                      class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center"
                                    >
                                      <span v-if="course.topic_count == 0">
                                        {{ course.topic_count }} Topics
                                      </span>
                                      <span v-else-if="course.topic_count == 1">
                                        {{ course.topic_count }} Topic
                                      </span>
                                      <span v-else-if="course.topic_count > 1">
                                        {{ course.topic_count }} Topics
                                      </span>
                                    </div>
                                  </div>
                                  <div class="row p-1" v-else>
                                    <div
                                      class="col-6 text-center sub-item-border-right"
                                    >
                                      <span v-if="course.subject_count == 0">
                                        {{ course.subject_count }} Subjects
                                      </span>
                                      <span
                                        v-else-if="course.subject_count == 1"
                                      >
                                        {{ course.subject_count }} Subject
                                      </span>
                                      <span
                                        v-else-if="course.subject_count > 1"
                                      >
                                        {{ course.subject_count }} Subjects
                                      </span>
                                    </div>
                                    <div class="col-6 text-center">
                                      <span v-if="course.topic_count == 0">
                                        {{ course.topic_count }} Topics
                                      </span>
                                      <span v-else-if="course.topic_count == 1">
                                        {{ course.topic_count }} Topic
                                      </span>
                                      <span v-else-if="course.topic_count > 1">
                                        {{ course.topic_count }} Topics
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="time-area">
                                  <div class="subs mb-2">
                                    Start On:
                                    <span>{{ course.start_date }}</span>
                                  </div>
                                  <div class="subs">
                                    End On: <span>{{ course.end_date }}</span>
                                  </div>
                                </div>
                                <div
                                  class="select-area"
                                  v-if="course.bundle_course.length > 0"
                                >
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#bundle-course-select-modal"
                                    class="btn btn-secondary"
                                    @click="
                                      showBundleCourses(
                                        course.bundle_course,
                                        course.name
                                      )
                                    "
                                  >
                                    view courses/detail
                                  </button>
                                </div>
                                <div class="select-area" v-else>
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#subject-select-modal"
                                    class="btn btn-secondary"
                                    @click="showSubjects(course.id)"
                                  >
                                    View subject/detail
                                  </button>
                                </div>

                                <p class="text-center price-tile mb-2">
                                  Full course fee
                                </p>
                                <h3 class="course-fee-body">
                                  {{ currency.symbol }}
                                  {{ numberWithCommas(course.fee) }}
                                  <sup>{{ currency.code }}</sup>
                                </h3>
                                <div class="modern-body" v-if="userPermissions.course_register == 1">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#view_payments-select-modal"
                                    class="btn btn-primary btn-info btn-custom__cosure_terms"                                    
                                    @click="loadPaymentInstallment(course.id)"                                
                                  >
                                    View payment terms
                                  </button>
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#installment-select-modal"
                                    class="btn btn-primary btn-info"
                                    @click="loadSchedule(course.id)"
                                    v-if="!course.is_selected"
                                  >
                                    Register
                                  </button>
                                  <button
                                    v-else
                                    type="button"
                                    class="btn btn-primary btn-info registered"
                                    disabled
                                  >
                                    Registered
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="card">
                    <div class="card-header" id="headingThree">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Lessons
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseThree"
                      class="collapse show"
                      aria-labelledby="headingThree"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4 col-lg-3 col-xl-3 course-card">
                            <div class="course-card">
                              <div class="modern-card">
                                <div class="modern-head">
                                  <h2>Diploma in Information Technology</h2>
                                </div>
                                <div class="modern-stat">
                                  <div class="time-md">3 Months</div>
                                  <div class="count-md">20 Hours</div>
                                </div>
                                <div class="modern-stat sub-item">
                                  <ul>
                                    <li>04 subjects</li>
                                    <li>12 Lessons</li>
                                    <li>48 Topics</li>
                                  </ul>
                                </div>
                                <div class="time-area">
                                  <div class="subs start">
                                    Start On: <span>2021-02</span>
                                  </div>
                                  <div class="subs end">
                                    End On: <span>2021-02</span>
                                  </div>
                                </div>
                                <div class="select-area">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#subject-select-modal"
                                    class="btn btn-secondary"
                                  >
                                    Select your Subjects
                                  </button>
                                </div>
                                <h3>Rs. 34000.00</h3>
                                <div class="modern-body">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    class="btn btn-primary btn-info"
                                  >
                                    Register
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-4 col-lg-3 col-xl-3 course-card">
                            <div class="course-card">
                              <div class="modern-card">
                                <div class="modern-head">
                                  <h2>Diploma in Information Technology</h2>
                                </div>
                                <div class="modern-stat">
                                  <div class="time-md">3 Months</div>
                                  <div class="count-md">20 Hours</div>
                                </div>
                                <div class="modern-stat sub-item">
                                  <ul>
                                    <li>04 subjects</li>
                                    <li>12 Lessons</li>
                                    <li>48 Topics</li>
                                  </ul>
                                </div>
                                <div class="time-area">
                                  <div class="subs start">
                                    Start On: <span>2021-02</span>
                                  </div>
                                  <div class="subs end">
                                    End On: <span>2021-02</span>
                                  </div>
                                </div>
                                <div class="select-area">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#subject-select-modal"
                                    class="btn btn-secondary"
                                  >
                                    Select your Subjects
                                  </button>
                                </div>
                                <h3>Rs. 34000.00</h3>
                                <div class="modern-body">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    class="btn btn-primary btn-info"
                                  >
                                    Register
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-4 col-lg-3 col-xl-3 course-card">
                            <div class="course-card">
                              <div class="modern-card">
                                <div class="modern-head">
                                  <h2>Diploma in Information Technology</h2>
                                </div>
                                <div class="modern-stat">
                                  <div class="time-md">3 Months</div>
                                  <div class="count-md">20 Hours</div>
                                </div>
                                <div class="modern-stat sub-item">
                                  <ul>
                                    <li>04 subjects</li>
                                    <li>12 Lessons</li>
                                    <li>48 Topics</li>
                                  </ul>
                                </div>
                                <div class="time-area">
                                  <div class="subs start">
                                    Start On: <span>2021-02</span>
                                  </div>
                                  <div class="subs end">
                                    End On: <span>2021-02</span>
                                  </div>
                                </div>
                                <div class="select-area">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#subject-select-modal"
                                    class="btn btn-secondary"
                                  >
                                    Select your Subjects
                                  </button>
                                </div>
                                <h3>Rs. 34000.00</h3>
                                <div class="modern-body">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    class="btn btn-primary btn-info"
                                  >
                                    Register
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="card" v-if="!no_data">
                  <div class="empty-data">
                    <img src="/media/icons/empty.png" />
                    <h2>No Records Available</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
    <div
      class="modal fade modern"
      id="subject-select-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Subjects</h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body">
            <div
              class="alert alert-success"
              id="subjectadd-success"
              style="display:none"
            ></div>
            <div
              class="alert alert-danger"
              id="subjectadd-error"
              style="display:none"
            ></div>
            <div v-if="userPermissions.add_subject == 1">
              <div v-if="subject_detail.length > 0" class="row">
                <div
                  v-for="(subject, index) in subject_detail"
                  :key="index"
                  class="col-md-12"
                >
                  <div class="form-group">
                    <span
                      class="m-switch m-switch--sm m-switch--icon subject-switch"
                    >
                      <label
                        aria-label="Show Institue Key"
                        data-balloon-pos="right"
                        ><input
                          type="checkbox"
                          v-model="subject.status"
                          name="playbar"
                        />
                        <span class="item-name"></span>
                        {{ subject.name }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="text-center">
                <h5>No subjects available</h5>
              </div>
            </div>
            <div v-else>
              <div v-if="subject_detail.length > 0" class="row">
                <div
                  v-for="(subject, index) in subject_detail"
                  :key="index"
                  class="col-md-12"
                >
                  <div class="form-group">
                    <span
                      class="m-switch m-switch--sm m-switch--icon subject-switch"
                    >
                      <label
                        aria-label="Show Institue Key"
                        data-balloon-pos="right"
                      >
                        <span class="item-name"></span>
                        {{ subject.name }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="text-center">
                <h5>No subjects available</h5>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="
                subject_detail.length > 0 && userPermissions.add_subject == 1
              "
              type="button"
              @click="addSubjects()"
              class="btn btn-primary"
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade modern"
      id="installment-select-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Select Installment
            </h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body">
            <div
              class="alert alert-success"
              id="courseadd-success"
              style="display:none"
            ></div>
            <div
              class="alert alert-danger"
              id="courseadd-error"
              style="display:none"
            ></div>

            <div v-if="payment_schedule.length > 0" class="row">
              <div
                v-for="(schedule, x) in payment_schedule"
                :key="x"
                class="col-md-12"
              >
                <div class="form-group">
                  <span
                    class="m-switch m-switch--sm m-switch--icon subject-switch"
                  >
                    <label
                      aria-label="Show Institue Key"
                      data-balloon-pos="right"
                      ><input
                        id="installment"
                        type="radio"
                        v-model="schedule_id"
                        :value="schedule.id"
                        name="schedulecheck"
                      />
                      <span class="item-name"></span>
                      {{ schedule.text }}
                    </label>
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="text-center">
              <h5>No Schedules available</h5>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="saveCourse()" class="btn btn-primary">
              Register
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- start: view payments terms -->
    <div
      class="modal fade modern"
      id="view_payments-select-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Payment terms
            </h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body">
            <div v-if="payment_installments.length !=0">
              <div class="accordian-bundle-course courses-name">
                
              </div>
              <div
                class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow"
                id="m_accordion_4"
                role="tablist"
              >
                <!--begin::Item-->
                <div
                  v-for="(payment_installment,index) in payment_installments"
                  :key="payment_installment.id"
                  class="m-accordion__item mb-2"
                >
                  <div                   
                    class="m-accordion__item-head tooltiptext_block"
                    role="tab"
                    :id="'m_accordion_4_item_' + index + '_head'"
                    data-toggle="collapse"
                    :href="'#m_accordion_4_item_' + index + '_body'"
                    aria-expanded="true"
                  >
                    <span class="tooltiptext">Click to Expand</span>
                    <div class="accordian-bundle-course  bundle-course-name">
                      <span>{{payment_installment[0].schedule.name}}</span> <span> ({{payment_installment[0].schedule.installment}} Installments)</span>
                                   
                    </div>
                  </div>
                  <div
                    class="m-accordion__item-body collapse"
                    :id="'m_accordion_4_item_' + index + '_body'"
                    role="tabpanel"
                    :aria-labelledby="'m_accordion_4_item_' + index + '_head'"
                    data-parent="#m_accordion_4"
                  >
                    <div>
                      <div
                        v-for="(n,ind) in payment_installment" :key="ind"                        
                        class="accordian-bundle-course  bundle-course-subjects"
                      >
                        <div>                        
                          <span class="mx-1">{{ind + 1}}</span> <span class="mx-2">{{n.bill_date}}</span> <span class="mx-2">{{ currency.symbol }} {{numberWithCommas(n.term_fee)}}  <sup>{{ currency.code }}</sup> </span>    
                        </div>
                      </div>
                    </div>                    
                  </div>
                </div>
                <!--end::Item-->
              </div>
            </div>
           
            <div v-else class="text-center">
              <h5>No payment terms available</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: view payments terms -->

    <!-- start: bundle courses model-->
    <div
      class="modal fade modern"
      id="bundle-course-select-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Bundle Courses</h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
              @click="reloadModel"
            />
          </div>
          <div class="modal-body">
            <div
              class="alert alert-success"
              id="subjectadd-success"
              style="display:none"
            ></div>
            <div
              class="alert alert-danger"
              id="subjectadd-error"
              style="display:none"
            ></div>

            <div v-if="bundlecourse_list.length > 0">
              <div class="accordian-bundle-course courses-name">
                {{ bundle_course_name }}
              </div>
              <div
                class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow"
                id="m_accordion_4"
                role="tablist"
              >
                <!--begin::Item-->
                <div
                  v-for="(bundleCourse, index) in bundlecourse_list"
                  :key="index"
                  class="m-accordion__item mb-2"
                >
                  <div
                    @click="getBundleCourseDetails(bundleCourse.id)"
                    class="m-accordion__item-head tooltiptext_block"
                    role="tab"
                    :id="'m_accordion_4_item_' + index + '_head'"
                    data-toggle="collapse"
                    :href="'#m_accordion_4_item_' + index + '_body'"
                    aria-expanded="true"
                  >
                    <span class="tooltiptext">Click to Expand</span>
                    <div class="accordian-bundle-course  bundle-course-name">
                      {{ index + 1 }}. {{ bundleCourse.name }}
                    </div>
                  </div>
                  <div
                    class="m-accordion__item-body collapse"
                    :id="'m_accordion_4_item_' + index + '_body'"
                    role="tabpanel"
                    :aria-labelledby="'m_accordion_4_item_' + index + '_head'"
                    data-parent="#m_accordion_4"
                  >
                    <div v-if="bundlecourse_subjects.length > 0">
                      <div
                        v-for="(subject, index) in bundlecourse_subjects"
                        :key="index"
                        class="accordian-bundle-course  bundle-course-subjects"
                      >
                        <div>
                          <div class="dot"></div>
                          {{ subject.name }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      class="accordian-bundle-course  bundle-course-subjects"
                    >
                      No Subjcts Available
                    </div>
                  </div>
                </div>
                <!--end::Item-->
              </div>
            </div>
            <div class="text-center" v-else>
              <h5>No Courses available</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: bundle courses model-->
  </div>
</template>

<script>
import axios from "axios";
import { FacebookLoader } from "vue-content-loader";
var Cookies = require("vue-cookies");
var Config = require("../router/Config");
var $ = require("jquery");
var userPermissions = Cookies.get("userPermissions");
export default {
  name: "browsecourse",
  components: { FacebookLoader },
  data() {
    return {
      loaderlist: true,
      no_data: true,
      course_list: [],
      course_type: [],
      subject_detail: [],
      education: [],
      grades: [],
      offering: [],
      grade_id: "",
      offering_type_id: "",
      education_id: "",
      course_id: "",
      currency: [],
      userPermissions: [],
      payment_schedule: [],
      schedule_id: "",
      bundlecourse_list: [],
      bundle_course_name: "",
      bundlecourse_subjects: [],
      keyword: "",
      payment_installments: []
    };
  },
  beforeCreate: function() {
    if (userPermissions.brows_course === 0) {
      this.$router.push("/");
    }
  },
  mounted() {
    this.userPermissions = Cookies.get("userPermissions");
    this.currency = Cookies.get("currency");
    this.loadFilters();
    this.searchCourse();
  },
  methods: {
    loadFilters: function() {
      axios
        .get(
          Config.API_URL +
            "/api/fe/course/filters/" +
            Cookies.get("studentId") +
            "?token=" +
            Cookies.get("accessToken")
        )
        .then(response => {
          this.course_type = response.data.course_type;
          this.education = response.data.education;
          this.offering = response.data.offering;
          this.grades = response.data.grade;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    searchCourse: function() {
      const self = this;
      this.loaderlist = true;
      this.no_data = true;
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/course/search?token=" +
            Cookies.get("accessToken"),
          {
            student_id: Cookies.get("studentId"),
            grade_id: self.grade_id,
            education_id: self.education_id,
            offering_type_id: self.offering_type_id,
            keyword: self.keyword
          }
        )
        .then(response => {
          if (response.data.res === 1) {
            self.course_list = response.data.data;
            if (self.course_list.length <= 0) {
              self.no_data = false;
            }
            self.loaderlist = false;
          } else {
            console.log("error");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showSubjects: function(courseId) {
      this.course_id = courseId;
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/course/load/subjects?token=" +
            Cookies.get("accessToken"),
          {
            student_id: Cookies.get("studentId"),
            course_id: courseId
          }
        )
        .then(response => {
          var subjectData = response.data;
          this.subject_detail = subjectData.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showBundleCourses: function(bundle_courses, courseName) {
      this.bundlecourse_subjects = [];
      this.bundlecourse_list = [];
      this.bundlecourse_list = bundle_courses;
      this.bundle_course_name = courseName;
      // this.course_id = courseId;
    },
    getBundleCourseDetails: function(bundleCourseId) {
      this.bundlecourse_subjects = [];
      this.axios
        .get(
          Config.API_URL +
            "/api/fe/course/subjects/" +
            bundleCourseId +
            "?token=" +
            Cookies.get("accessToken")
        )
        .then(response => {
          var subjectData = response.data;
          this.bundlecourse_subjects = subjectData.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addSubjects: function() {
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/student/add/subjects?token=" +
            Cookies.get("accessToken"),
          {
            student_id: Cookies.get("studentId"),
            course_id: this.course_id,
            subjects: this.subject_detail
          }
        )
        .then(response => {
          if (response.data.res === 1) {
            $("#subjectadd-success").html(response.data.data);
            $("#subjectadd-success")
              .fadeTo(5000, 500)
              .slideUp(500, function() {
                $("#subjectadd-success").slideUp(500);
              });
          } else {
            $("#subjectadd-error").html(response.data.data);
            $("#subjectadd-error")
              .fadeTo(5000, 500)
              .slideUp(500, function() {
                $("#subjectadd-error").slideUp(500);
              });
          }
        })
        .catch(function(error) {
          $("#subjectadd-error").html(error);
          $("#subjectadd-error")
            .fadeTo(5000, 500)
            .slideUp(500, function() {
              $("#subjectadd-error").slideUp(500);
            });
        });
    },
    loadSchedule: function(courseId) {
      this.course_id = courseId;
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/student/course/loadschedule?token=" +
            Cookies.get("accessToken"),
          {
            student_id: Cookies.get("studentId"),
            course_id: courseId
          }
        )
        .then(response => {
          this.payment_schedule = response.data.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveCourse: function() {
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/student/course/register-coruse?token=" +
            Cookies.get("accessToken"),
          {
            student_id: Cookies.get("studentId"),
            course_id: this.course_id,
            schedule: this.schedule_id
          }
        )
        .then(response => {
          if (response.data.res === 1) {
            $("#courseadd-success").html(response.data.msg);
            $("#courseadd-success")
              .fadeTo(5000, 500)
              .slideUp(500, function() {
                $("#courseadd-success").slideUp(500);
              });
            this.searchCourse();
          } else {
            $("#courseadd-error").html(response.data.msg);
            $("#courseadd-error")
              .fadeTo(5000, 500)
              .slideUp(500, function() {
                $("#courseadd-error").slideUp(500);
              });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      $("input:radio[name=schedulecheck]:checked")[0].checked = false;
    },
    reloadModel: function() {
      location.reload();
    },

  
    loadPaymentInstallment: function(course_id) {
      this.payment_installments = [];      
      axios.post(Config.API_URL +"/api/fe/course/payment-terms?token=" + Cookies.get("accessToken"),
       {
          course_id: course_id
        }).then(response => {           
            this.payment_installments = response.data.data;    
        }).catch(function(error) {
            console.log(error);
        });
    },
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/component/browsecourse/browsecourse";
.modern-stat-border {
  border-right: 1px solid #fff;
}

.sub-item-border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.125);
}

.sub-items-border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.125);
}

@media (max-width: 767px) {
  .sub-items-border-right {
    border-right: none !important;
  }
}

.m-accordion.m-accordion--section .m-accordion__item .m-accordion__item-head,
.m-accordion.m-accordion--section .m-accordion__item .m-accordion__item-body {
  background-color: #fff !important;
  border-right: solid 1px #e2e2e2;
  border-left: solid 1px #e2e2e2;
  border-bottom: solid 1px #e2e2e2;
  border-radius: 0 0 5px 5px;
}

.m-accordion.m-accordion--section .m-accordion__item .m-accordion__item-head {
  background-color: #fff !important;
  padding: 1rem;
  border: solid 1px #e2e2e2;
  border-radius: 5px 5px 0 0;
}

.tooltiptext_block {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltiptext_block .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #ff0700;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
}

.tooltiptext_block:hover .tooltiptext {
  visibility: visible;
}

.accordian-bundle-course {
  color: #222;
  font-weight: 500;
}

.bundle-course-heading {
  font-size: 1.1rem;
}

.bundle-course-name {
  font-size: 1rem;
}

.bundle-course-subjects {
  padding: 10px 15px;
}

.courses-name {
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 20px;
}

.dot {
  top: 4px;
  vertical-align: baseline;
}

.modern-card .time-area .subs {
  width: 100%;
  float: none;
  font-weight: 700;
  font-size: 0.9rem;
  border-radius: 5px;
}

.modern-card .time-area .subs:hover {
  background-color: #ededed;
}

.modern-card .time-area {
  padding: 10px 5px;
}

.modern-card .course-fee-body:hover {
  background-color: #ededed;
}

.bundle-pack {
  position: absolute;
  top: -6px;
  right: -5px;
  z-index: 3;
  padding: 4.3px;
  border-radius: 3px;
  background-color: #f5430b;
  width: 45px;
  height: 45px;
  text-align: center;
  border-radius: 50%;
  color: #fff;

  span {
    float: left;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    position: relative;
    top: 0px;
  }

  b {
    float: left;
    width: 100%;
    font-size: 0.7rem;
    position: relative;
    top: -7px;
    font-weight: 500;
    color: #ffffff;
    left: -1px;
  }
}



</style>
